
import React from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MobileSidebarProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  side?: 'left' | 'right';
  className?: string;
}

export function MobileSidebar({ 
  open, 
  onOpenChange, 
  children, 
  side = 'left',
  className 
}: MobileSidebarProps) {
  // Close sidebar when clicking overlay
  const handleOverlayClick = () => {
    onOpenChange(false);
  };

  // Prevent closing when clicking inside the sidebar
  const handleSidebarClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <>
      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 z-50 bg-black/80 transition-opacity duration-300"
          onClick={handleOverlayClick}
        />
      )}
      
      {/* Sidebar */}
      <div
        className={cn(
          "fixed inset-y-0 z-50 w-[18rem] bg-sidebar text-sidebar-foreground transition-transform duration-300 ease-in-out",
          side === 'left' 
            ? `left-0 ${open ? 'translate-x-0' : '-translate-x-full'}` 
            : `right-0 ${open ? 'translate-x-0' : 'translate-x-full'}`,
          className
        )}
        onClick={handleSidebarClick}
      >
        {/* Close button */}
        <button
          onClick={() => onOpenChange(false)}
          className="absolute right-4 top-4 z-10 rounded-sm p-1 opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </button>
        
        {/* Scrollable content area */}
        <div className="flex h-full w-full flex-col overflow-y-auto">
          {children}
        </div>
      </div>
    </>
  );
}
